export class MealDateSummary {

    mealid : number
    details : string
    orderNumber : number
    mealdays : number[];


    constructor(mealid: number, details: string, orderNumber: number, mealdays: number[]) {
        this.mealid = mealid;
        this.details = details;
        this.orderNumber = orderNumber;
        this.mealdays = mealdays;
    }
}